import "./FooterHandleStatus.css";

import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import FlakyOutlinedIcon from "@mui/icons-material/FlakyOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";

import { ExpertEstmStatusTitleEnum } from "core/enums";
import ProjectTreeRowCircleStatus from "pages/EstimateViewer/ProjectTree/ProjectTreeRowCircleStatus";

const FooterHandleStatus = ({ meta }) => {
	const handleStatus = meta?.handle_status;
	const circleStatus = meta?.circle_status;
	if (!handleStatus || !circleStatus) return;

	return (
		<div className="footer-handle-status" style={{ overflow: "hidden" }}>
			<span className="footer-handle-row" title="Всего загружено" style={{ whiteSpace: "nowrap" }}>{`Всего ЛСР: ${handleStatus.upload}`}</span>
			<span className="footer-handle-row">
				<FlakyOutlinedIcon />
				{`${handleStatus.upload_with_out_valid}`}
			</span>
			<span className="footer-handle-row" title={ExpertEstmStatusTitleEnum.VALID}>
				<CheckCircleOutlinedIcon />
				{`${handleStatus.valid}`}
			</span>
			<span className="footer-handle-row" title={ExpertEstmStatusTitleEnum.NOT_VALID}>
				<HighlightOffOutlinedIcon />
				{`${handleStatus.not_valid}`}
			</span>
			<span className="footer-handle-row">|</span>
			<span className="footer-handle-row">
				<ProjectTreeRowCircleStatus rowObj={{ valid_status: "success" }} />
				{`${circleStatus.success}`}
			</span>
			<span className="footer-handle-row">
				<ProjectTreeRowCircleStatus rowObj={{ valid_status: "warning" }} />
				{`${circleStatus.warning}`}
			</span>
			<span className="footer-handle-row">
				<ProjectTreeRowCircleStatus rowObj={{ valid_status: "error" }} />
				{`${circleStatus.error}`}
			</span>
		</div>
	);
};

export default FooterHandleStatus;
